'use client'

import { SystemNotification } from '@/shared/schema/system-notification'

export interface GetNotificationsParams {
  page: string
  orgId?: string
}

export interface DismissNotificationParams {
  notificationId: string
  organizationId?: string
}

export const notificationApi = {
  async getNotifications(params: GetNotificationsParams): Promise<SystemNotification[]> {
    const searchParams = new URLSearchParams({
      page: params.page
    })

    if (params.orgId) {
      searchParams.set('orgId', params.orgId)
    }

    const response = await fetch(`/api/notifications?${searchParams.toString()}`)
    if (!response.ok) {
      throw new Error('Failed to fetch notifications')
    }
    return response.json()
  },

  async dismissNotification(params: DismissNotificationParams): Promise<void> {
    const response = await fetch('/api/notifications/dismiss', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        notificationId: params.notificationId,
        organizationId: params.organizationId
      })
    })

    if (!response.ok) {
      throw new Error('Failed to dismiss notification')
    }
  }
}